// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

import { BaseLeaderboardEntity, LeaderboardRow, LeaderboardConfig } from './leaderboard.entity';
import { TECHNICAL_INFLUENCE_LEADERBOARD_MOCK_DATA } from '../mocks/technical-influence-leaderboard.mock';

/**
 * Technical Influence Leaderboard Entity (v2)
 *
 * Provides configuration for the Technical Influence Leaderboard.
 * This entity extends the base leaderboard with technical-specific configuration.
 */
export class TechnicalInfluenceLeaderboardEntity extends BaseLeaderboardEntity {
  /**
   * Title for the Technical Influence Leaderboard
   */
  static readonly TITLE = 'Technical Influence Leaderboard';

  /**
   * Default time range type for API calls
   */
  static readonly DEFAULT_TIME_RANGE_TYPE = 'last_2_years';

  /**
   * Get the configuration for the Technical Influence Leaderboard
   */
  static getConfig(): LeaderboardConfig {
    return {
      title: this.TITLE,
      columns: this.COLUMNS
    };
  }

  /**
   * Get mock data for Technical Influence Leaderboard
   * Mock data is stored in a separate file for better maintainability
   */
  static getMockData(): LeaderboardRow[] {
    return TECHNICAL_INFLUENCE_LEADERBOARD_MOCK_DATA;
  }
}
